export default __webpack_public_path__ + "static/media/calendarIcon.93e6093e.svg";